import { Backdrop, Box, CircularProgress, createStyles, makeStyles, Typography } from '@material-ui/core';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import ReactDOM from 'react-dom';
import '../util/string';

const PercentageProgressRingStyles = makeStyles((theme) =>
    createStyles({
        backdrop: {
            zIndex: theme.zIndex.modal + 1,
            color: '#fff',
        },
    })
);
const PercentageProgressRing = ({ open, label }, ref) => {
    const { backdrop } = PercentageProgressRingStyles();

    const [progress, setProgress] = useState(0);

    useImperativeHandle(ref, () => ({
        onProgressChange: ({ loaded, total }) => {
            setProgress(Math.ceil((loaded / total) * 99));
        },
    }));
    return ReactDOM.createPortal(
        <Backdrop className={backdrop} open={open}>
            <Box position="relative" display="inline-flex">
                <CircularProgress variant="static" size={60} color="inherit" value={progress} />
                <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Typography variant="body1">{progress}%</Typography>
                    <Typography variant="body1">{label}</Typography>
                </Box>
            </Box>
        </Backdrop>,
        document.body // Render the portal outside the parent container
    );
};
export default forwardRef(PercentageProgressRing);
